import { Thead, Tr, Th, Text, Flex } from "@chakra-ui/react";
import { SortUp, SortDown } from "@airhelp/icons";
import { useTranslations } from "contexts/LocalizationContext";
import type { TableProps } from "../Table.d";

const THead = ({ headerGroups }: Pick<TableProps, "headerGroups">) => {
  const translations = useTranslations();
  return (
    <Thead>
      {headerGroups.map((headerGroup) => (
        <Tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            const isSortedDesc = header.column.getIsSorted() === "desc";

            return (
              <Th
                key={header.id}
                px={4}
                _first={{ border: "none" }}
                onClick={header.column.getToggleSortingHandler()}
                role="columnheader"
                cursor={header.column.getCanSort() ? "pointer" : "default"}
                aria-sort={header.column.getIsSorted() ? (isSortedDesc ? "descending" : "ascending") : undefined}
              >
                <Text
                  as="span"
                  fontSize="sm"
                  textTransform="none"
                  color="primary.900"
                  fontWeight="400"
                  display="flex"
                  alignItems="flex-end"
                  minW="min-content"
                  whiteSpace="nowrap"
                  letterSpacing="normal"
                >
                  {header.column.columnDef.header ? translations(header.column.columnDef.header as string) : null}
                  {header.column.getCanSort() && (
                    <Flex flexDir="column" mt="2px" ml={0.5}>
                      <SortUp
                        opacity={header.column.getIsSorted() ? (isSortedDesc ? 0.5 : 1) : 0.5}
                        mb={-2.5}
                        boxSize={4}
                      />
                      <SortDown opacity={header.column.getIsSorted() ? (isSortedDesc ? 1 : 0.5) : 0.5} boxSize={4} />
                    </Flex>
                  )}
                </Text>
              </Th>
            );
          })}
        </Tr>
      ))}
    </Thead>
  );
};

export default THead;
